/**
 * Created by akrio on 2018/4/27.
 */

export const pricingPackageList = [
  {
    type: "FREE",
    price: "$0",
    background: " #da16ae",
    des: `+ Unlimited social account
+ 10 schedule per month per account`,
    active: true,
  },
  {
    type: "STARTER",
    price: "$10",
    background: " #dc0c94",
    des: `Everything in Free Plan:
+ 1 social account with unlimited schedules`,
  },
  {
    type: "PLUS",
    price: "$15",
    background: " #E10A85",
    des: `Everything in Free Plan:
+ 3 social account with unlimited schedules`,
  },
  {
    type: "PRO",
    price: "$20",
    background: " #e50779",
    des: `Everything in Free Plan plus:
+ 5 social account with unlimited schedules
+ 1 Manager`,
  },
  {
    type: "TEAM",
    price: "$50",
    background: " #ed035b",
    des: `Everything in Free Plan plus:
+ 20 social account with unlimited schedules
+ 4 Manager`,
  },
  {
    type: "BUSINESS",
    price: "$100",
    background: " #e50140",
    des: `Everything in Free Plan plus:
+ 20 social account with unlimited schedules
+ 4 Manager`,
  },
  {
    type: "BUSINESS",
    price: "$100",
    background: " #e50140",
    des: `Everything in Free Plan plus:
+ 20 social account with unlimited schedules
+ 4 Manager`,
  },
  {
    type: "BUSINESS",
    price: "$100",
    background: " #e50140",
    des: `Everything in Free Plan plus:
+ 20 social account with unlimited schedules
+ 4 Manager`,
  },
];
export const conformCountry = [
  "BR",
  "UA",
  "VN",
  "PE",
  "PL",
  "TH",
  "IN",
  "ID",
  "MY",
  "HR",
  "NP",
  "CO",
  "AL",
  "EG",
  "SV",
  "LB",
  "CL",
  "VE",
  "KZ",
  "EC",
  "PH",
  "TR",
  "SA",
  "EG",
  "AE",
  "QA",
  "JO",
  "KW",
  "BH",
  "IQ",
]; // 巴西，印度，印尼，马来西亚



// WEBPACK FOOTER //
// ./src/const/plan.js